import React from "react";
import './featuresection.css';
import type { FeatureProps } from "../../molecules/Feature/Feature";
import { Feature } from "../../molecules/Feature/Feature";

interface FeaturesSectionProps {
    features: FeatureProps[];
  }

// FeaturesSection component
const FeaturesSection: React.FC<FeaturesSectionProps> = ({ features }) => (
    <section className="section">
      <h2>Our Services</h2>
      <div className="feature-container">
        {features.map((feature, index) => (
          <Feature key={index} {...feature} />
        ))}
      </div>
    </section>
);
  

export { FeaturesSection };
export type { FeaturesSectionProps };